import { render, staticRenderFns } from "./MTalentIndex.vue?vue&type=template&id=13374ed8&"
import script from "./MTalentIndex.vue?vue&type=script&lang=js&"
export * from "./MTalentIndex.vue?vue&type=script&lang=js&"
import style0 from "./MTalentIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports